import currentDevice from 'current-device';

const isDesktop = currentDevice.desktop();
export default isDesktop;
